import {api} from '@eksab/api';
import {useInvalidateMe} from '@eksab/hooks';
import {useMutation} from '@tanstack/react-query';

export function useGiftCodeMutation() {
  const invalidateMe = useInvalidateMe();
  return useMutation((code: string) => api.post('v2/vouchers/redeem', {code}), {
    onSuccess: () => {
      invalidateMe();
    },
  });
}
